/**
 * How a cheque is crossed (ML-09 / GAP-007).
 *
 * The value is resolved in three steps when a cheque is registered: what the voucher says, then
 * the payable account the party settles through, then the paying bank account's own default. This
 * file is only the vocabulary shared by every screen that offers or displays it — one list, so a
 * label cannot drift between the voucher, the register and the print run.
 */
export const CROSSING_OPTIONS = [
  { value: 'ACCOUNT_PAYEE',  label: 'A/C Payee Only'   },
  { value: 'NOT_NEGOTIABLE', label: 'Not Negotiable'   },
  { value: 'OPEN',           label: 'Open (uncrossed)' },
] as const;

export const CROSSING_LABELS: Record<string, string> =
  Object.fromEntries(CROSSING_OPTIONS.map(o => [o.value, o.label]));
